import React from 'react';
import { Modal } from '@spotify-internal/anchor-ds';
import {
  ButtonPrimary,
  ButtonSecondary,
  LogoSpotify,
  spacer16,
  spacer24,
  Type,
} from '@spotify-internal/encore-web';
import { useT } from 'i18n/hooks/useT';
import styled from 'styled-components';

type SpotifyAccountDisconnectModalProps = {
  onClose: () => void;
};

const PaddedTitleText = styled.div`
  margin-top: ${spacer24};
`;

const SPOTIFY_UNLINK_LINK = 'https://www.spotify.com/us/account/apps/';

export const SpotifyAccountDisconnectModal = ({
  onClose,
}: SpotifyAccountDisconnectModalProps) => {
  const t = useT();

  return (
    <Modal
      isShowingCloseButton
      onClose={onClose}
      aria-labelledby="spotify-connect-initial-modal-title"
    >
      <Modal.Title id="spotify-connect-initial-modal-title">
        <LogoSpotify height={124} width={124} condensed useBrandColor={true} />
        <PaddedTitleText>
          {t(
            'SpotifyAccountDisconnectModal.Title',
            'Unlink your Spotify account',
            'you are about to unlink your Spotify account'
          )}
        </PaddedTitleText>
      </Modal.Title>
      <Modal.Body as="div">
        <Type paddingBottom={spacer16} as="p">
          {t(
            'SpotifyAccountDisconnectModal.Body.paragraph1',
            'If you unlink your account, automated ads will be disabled. To receive this month’s earnings, your balance must be $25 or more. You can log into Spotify Payouts to view your payment details.',
            'Informing you that you are about to unlink your Spotify account'
          )}
        </Type>
        <Type as="p">
          {t(
            'SpotifyAccountDisconnectModal.Body.paragraph2',
            'After you unlink this account, you’ll be able to link another Spotify account and set up Spotify Payouts again.',
            'Informing you that you can link another Spotify account and set up Spotify Payouts again'
          )}
        </Type>
      </Modal.Body>
      <Modal.Footer>
        <div>
          <ButtonSecondary onClick={onClose}>
            {t('Button.Cancel', 'Cancel', 'Cancel button text')}
          </ButtonSecondary>
          <ButtonPrimary href={SPOTIFY_UNLINK_LINK}>
            {t(
              'SpotifyAccountDisconnectModal.DisconnectActionButton',
              'Unlink Spotify',
              'Unlink Spotify button text'
            )}
          </ButtonPrimary>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
